import { expectDefined } from './util';

export class FrequencyCounter<T> {
  #counts = new Map<T, number>();

  add(item: T): void {
    if (this.#counts.has(item)) {
      this.#counts.set(item, expectDefined(this.#counts.get(item)) + 1);
    } else {
      this.#counts.set(item, 1);
    }
  }

  get counts(): Map<T, number> {
    return this.#counts;
  }

  get sortedCounts(): [T, number][] {
    return Array.from(this.#counts.entries()).sort((a, b) => b[1] - a[1]);
  }

  get top(): T | undefined {
    let maxCount = 0;
    let maxItem: T | undefined;
    for (const [text, count] of this.#counts.entries()) {
      if (count > maxCount) {
        maxCount = count;
        maxItem = text;
      }
    }
    return maxItem;
  }

  get items(): Set<T> {
    return new Set(this.#counts.keys());
  }
}
